"use client";
import React, {useState} from "react";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import {Button} from "@/components/ui/button";
import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";
import {useRouter} from "next/navigation";

export default function DeleteAction({type, idType, title, content,openDelete,setOpenDelete }){

    const axios = useAxiosAuth();
    const router = useRouter();


    function deleteAction(){
        let redirect = false;
        let redirectUrl = '';
        let uri = '';
        switch (type){
            case 'community':
                redirect = true;
                redirectUrl = '/dashboard/communities';
                uri = `communities/${idType}`;
            break;
            case 'comment':
                uri = `comments/${idType}`;
            break;
            case 'post' :
                uri = `posts/${idType}`;
            break;
        }

        axios.delete(uri)
            .then(() => {
                if(redirect){
                    router.push(redirectUrl);
                }else{
                    router.refresh();
                }
            })
            .catch(() => toast.error('Une erreur est survenue'))
    }

    return(

        <CWFResponsiveDialog
            open={openDelete}
            onOpenChange={setOpenDelete}
            title={<p className={"text-center"}>{title}</p>}
            trigger={null}
        >
                <div className={"px-4 py-2 grid gap-y-4"}>
                    <p className={"text-gray-900 text-center"}>{content}</p>
                    <div className={"flex justify-evenly"}>
                        <Button variant={"outline"} className={"hover:bg-primary text-primary hover:text-white border-primary"} onClick={() => setOpenDelete(false)}>Annuler</Button>
                        <Button variant={'destructive'} onClick={() => deleteAction()}>Confirmer</Button>
                    </div>
                </div>
        </CWFResponsiveDialog>

    )
}